import { loginWithBeatport } from 'spa/action_creators/oauth'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'

function BeatportLoginButton({ className, text }) {
  const dispatch = useDispatch()

  const handleBeatportLogin = useCallback(() => {
    dispatch(loginWithBeatport())
  }, [dispatch])

  return (
    <button className={className} onClick={handleBeatportLogin}>
      {text}
    </button>
  )
}

BeatportLoginButton.propTypes = {
  className: PropTypes.string,
  text: PropTypes.node,
}

export default BeatportLoginButton
